import React from 'react';
import SliderPartialRequestWithLabel from './SliderPartialRequestWithLabel';
import NumberedStepContainer from '../../EmployeeDashboard/Utils/NumberedStepContainer';
import { useTranslation } from 'react-i18next';

/**
 * @typedef {import('./SliderPartialRequest').SliderPartialRequestProps} SliderPartialRequestProps
 *
 */

/**
 *
 * @param {SliderPartialRequestProps & {
 *  classes: *;
 *  index: number;
 *  selectedPartial: string;
 * }} param0
 */
const SliderPartialRequestWrapper = ({
    classes,
    storeData = {},
    shifts,
    handleChange,
    index,
    selectedPartial,
    onSelectionInvalid,
    requestType,
}) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'billboard' });
    return (
        <NumberedStepContainer
            title={t('partialShiftOption')}
            stepNumber={index}
            classes={classes}
            isCollapsable
        >
            <SliderPartialRequestWithLabel
                shifts={shifts}
                storeData={storeData}
                requestType={requestType}
                handleChange={handleChange}
                onSelectionInvalid={onSelectionInvalid}
                selectedPartial={selectedPartial}
            />

        </NumberedStepContainer>
    );
}

export default SliderPartialRequestWrapper;
